<template>
  <div class="step-page-sheet">
    <Transition
      mode="out-in"
      enter-active-class="transition-opacity duration-200 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-150 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <StepLoadingSkeleton v-if="isLoading" key="loading" variant="payment" />
      <div v-else key="content" class="p-6 lg:px-8 lg:pt-4 lg:pb-8">
        <OrderPaidBanner :lock-reason="lockReason" />
        <p class="font-medium text-center text-dark-gray mb-6 lg:text-base">
          {{
            isEditable && !existsPayment
              ? "¡Último paso! Elige el medio y realiza el pago de tu suscripción"
              : newPayment.amount == null
              ? "Ya se cerro la campaña y no realizaste un pago"
              : "Detalles de tu pago"
          }}
        </p>
        <div v-if="effectiveTotal > 0">
          <TabGroup v-if="(isEditable && !existsPayment) || confirmMPPayment">
            <TabList
              class="flex p-1 space-x-1 bg-white border-aces border-2 rounded-lg"
            >
              <Tab as="template" v-slot="{ selected }">
                <button
                  :class="[
                    'w-full py-2.5 text-lg leading-5 font-medium rounded-lg',
                    'focus:outline-none',
                    selected
                      ? 'bg-aces shadow text-white'
                      : 'text-lg text-aces',
                  ]"
                >
                  Transferencia
                </button>
              </Tab>
              <Tab as="template" v-slot="{ selected }">
                <button
                  :class="[
                    'w-full py-2.5 text-lg leading-5 font-medium rounded-lg',
                    'focus:outline-none',
                    selected
                      ? 'bg-aces shadow text-white'
                      : 'text-lg text-aces',
                  ]"
                  @click="generateScript"
                >
                  Mercado pago
                </button>
              </Tab>
            </TabList>

            <TabPanels class="mt-2">
              <TabPanel
                :class="['bg-white rounded-md p-3', 'focus:outline-none']"
              >
                <form @submit.prevent="savePayment">
                  <p class="text-center mb-6">
                    Una vez hecha tu transferencia ingresa los siguientes datos
                  </p>
                  <div class="flex flex-col gap-2">
                    <!-- <div class="grid grid-cols-1 gap-2 lg:grid-cols-2 lg:gap-6"> -->
                    <div>
                      <label class="form-label">Banco</label>
                      <Listbox v-model="selectedBank">
                        <div class="relative">
                          <ListboxButton class="form-listbox-btn">
                            <span class="block truncate">{{
                              selectedBank
                            }}</span>
                            <span
                              class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                            >
                              <SelectorIcon
                                class="w-5 h-5 text-gray-400"
                                aria-hidden="true"
                              />
                            </span>
                          </ListboxButton>

                          <transition
                            leave-active-class="transition duration-100 ease-in"
                            leave-from-class="opacity-100"
                            leave-to-class="opacity-0"
                          >
                            <ListboxOptions
                              class="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-lg shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10"
                            >
                              <ListboxOption
                                v-slot="{ active, selected }"
                                v-for="bank in banks"
                                :key="bank"
                                :value="bank"
                                as="template"
                              >
                                <li
                                  :class="[
                                    active
                                      ? 'text-white bg-aces'
                                      : 'text-black',
                                    'cursor-default select-none relative py-2 pl-10 pr-4',
                                  ]"
                                >
                                  <span
                                    :class="[
                                      selected ? 'font-medium' : 'font-normal',
                                      'block truncate',
                                    ]"
                                    >{{ bank }}</span
                                  >
                                  <span
                                    v-if="selected"
                                    class="absolute inset-y-0 left-0 flex items-center pl-3 text-aces"
                                  >
                                    <CheckIcon
                                      class="w-5 h-5"
                                      aria-hidden="true"
                                    />
                                  </span>
                                </li>
                              </ListboxOption>
                            </ListboxOptions>
                          </transition>
                        </div>
                      </Listbox>
                    </div>
                    <div>
                      <label class="form-label">Número de transferencia</label>
                      <input
                        required
                        v-model="newPayment.location"
                        type="text"
                        class="form-input"
                      />
                    </div>
                    <div>
                      <label class="form-label">Fecha de pago</label>
                      <div>
                        <input
                          required
                          v-model="newPayment.bankOperationDate"
                          type="date"
                          class="form-input"
                        />
                      </div>
                    </div>
                    <div>
                      <label class="form-label">Comprobante</label>
                      <input
                        id="file"
                        required
                        type="file"
                        class="form-input"
                      />
                    </div>
                  </div>
                  <div class="mt-6">
                    <div
                      class="flex items-center space-x-2 justify-center my-2 w-full text-black bg-light-gray p-4 py-2 font-medium rounded-md focus:outline-none  uppercase lg:text-lg"
                      disabled
                      v-if="chargeButton"
                    >
                      <span>
                        Cargando
                      </span>
                      <img
                        src="icons/spinner-solid.svg"
                        alt=""
                        class="w-4 h-4 animate-spin"
                      />
                    </div>
                    <button
                      v-else-if="!chargeButton"
                      type="submit"
                      class="btn-primary my-2 lg:text-lg"
                    >
                      Cargar pago
                    </button>
                    <div v-if="effectiveTotal > 0">
                      <!-- <button
                      type="button"
                      class="my-2 w-full text-white bg-aces p-4 py-2 font-medium rounded-md focus:outline-none  uppercase lg:text-xl"
                      @click="isShowBancos = !isShowBancos"
                    >
                      <span v-if="isShowBancos">Ocultar Datos Bancarios</span>
                      <span v-else>Mostrar Datos Bancarios</span>
                    </button> -->

                      <h1 class="text-center text-lg font-medium mt-5">
                        Datos bancarios
                      </h1>
                      <Bancos :isShow="isShowBancos" />
                    </div>
                  </div>
                </form>
              </TabPanel>
              <TabPanel
                :class="[
                  'bg-white rounded-lg p-3',
                  'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60',
                ]"
              >
                <button
                  type="button"
                  @click="openMPCheckout"
                  class="btn-primary my-2 lg:text-lg"
                >
                  Pagar con Mercado Pago
                </button>
              </TabPanel>
            </TabPanels>
          </TabGroup>
          <div class="flex flex-col gap-2" v-else>
            <div v-if="newPayment.type">
              <label class="form-label">Tipo de pago</label>
              <input
                required
                v-model="paymentTypes[newPayment.type]"
                type="text"
                disabled
                class="form-input-readonly"
              />
            </div>
            <div v-if="newPayment.bank">
              <label class="form-label">Banco</label>
              <input
                required
                v-model="newPayment.bank"
                type="text"
                disabled
                class="form-input-readonly"
              />
            </div>
            <div v-if="newPayment.location">
              <label class="form-label">Número de transferencia</label>
              <input
                required
                v-model="newPayment.location"
                type="text"
                disabled
                class="form-input-readonly"
              />
            </div>
            <div v-if="newPayment.bankOperationDate">
              <label class="form-label">Fecha de pago</label>
              <input
                required
                :value="
                  new Date(newPayment.bankOperationDate)
                    .toLocaleDateString()
                    .split(' ')[0]
                "
                type="text"
                disabled
                class="form-input-readonly"
              />
            </div>
            <div
              v-if="
                newPayment.fileURL &&
                  newPayment.fileURL.split('.').pop() !== 'pdf'
              "
            >
              <label class="form-label">Comprobante de pago</label>
              <img
                :src="newPayment.fileURL"
                class="w-full h-60 object-contain bg-white rounded-lg cursor-pointer border border-light-gray shadow-sm p-2"
                alt="Comprobante de pago"
                @click="isOpen = true"
              />
            </div>
          </div>
        </div>
        <div v-else class="mt-6 flex flex-col justify-center items-center">
          <div>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="false"
              data-icon="box-open"
              class="svg-inline--fa fa-box-open fa-w-20 h-60 w-60"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
            >
              <path
                fill="#4B5563"
                d="M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
              ></path>
            </svg>
          </div>
          <div>
            <h2
              class="font-medium mt-16 mb-4 px-12 lg:self-start text-gray-600"
            >
              Todavía no ha hecho una compra...
            </h2>
          </div>
        </div>
      </div>
    </Transition>
    <TransitionRoot appear :show="isConfirmOpen" as="template">
      <Dialog as="div" @close="cancelConfirm">
        <div class="fixed inset-0 z-50 overflow-y-auto">
          <div class="min-h-screen px-4 text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <DialogOverlay
                class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
              />
            </TransitionChild>

            <span class="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <div
                class="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl rounded-2xl border border-gray-100"
              >
                <DialogTitle
                  as="h3"
                  class="text-lg font-medium leading-6 text-gray-900 text-center mb-3"
                >
                  Confirmá tus datos
                </DialogTitle>
                <p class="text-sm text-gray-600 text-center mb-4">
                  Tu suscripción se asocia a:
                </p>
                <div class="grid grid-cols-1 gap-3 mb-4">
                  <div v-if="church.churchName">
                    <label class="block text-xs font-light text-gray-500">
                      Iglesia
                    </label>
                    <p class="font-medium">{{ church.churchName }}</p>
                  </div>
                  <div v-if="church.coordinatorName">
                    <label class="block text-xs font-light text-gray-500">
                      Coordinador
                    </label>
                    <p class="font-medium">{{ church.coordinatorName }}</p>
                  </div>
                  <div v-if="!church.churchName && !church.coordinatorName">
                    <p class="text-sm text-gray-500 italic">
                      No pudimos cargar tus datos de iglesia.
                    </p>
                  </div>
                </div>
                <p class="text-xs text-gray-500 italic mb-5">
                  Si estos datos no son correctos, podés actualizarlos antes de
                  pagar.
                </p>
                <div class="flex flex-col gap-2">
                  <button
                    type="button"
                    class="btn-primary"
                    @click="confirmPayment"
                  >
                    Confirmar y continuar
                  </button>
                  <button
                    type="button"
                    class="btn-secondary"
                    @click="goEditData"
                  >
                    Editar mis datos
                  </button>
                  <button
                    type="button"
                    class="btn-neutral"
                    @click="cancelConfirm"
                  >
                    Volver al carrito
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>

    <ImageViewer
      v-if="isOpen"
      :imageUrl="newPayment.fileURL"
      @close="isOpen = false"
      class="z-10"
    />
    <TransitionRoot appear :show="isModalOpen" as="template">
      <Dialog as="div" @close="closeModal">
        <div class="fixed inset-0 z-50 overflow-y-auto">
          <div class="min-h-screen px-4 text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <DialogOverlay
                class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
              />
            </TransitionChild>

            <span class="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <div
                class="inline-block w-full max-w-md p-8 my-8 overflow-hidden text-center align-middle transition-all transform bg-white shadow-2xl rounded-2xl border border-gray-100"
              >
                <DialogTitle
                  as="h3"
                  class="text-lg font-medium leading-6 text-gray-900"
                >
                  <div class="flex flex-col items-center">
                    <div class="relative mb-6">
                      <div
                        class="w-20 h-20 bg-aces bg-opacity-30 rounded-full flex items-center justify-center"
                      >
                        <svg
                          class="w-12 h-12 text-aces"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </div>
                    </div>

                    <h2 class="text-2xl font-bold text-gray-900 mb-3">
                      ¡Pago Exitoso!
                    </h2>

                    <p class="text-gray-600 text-base leading-relaxed mb-8">
                      Tu pago ha sido procesado correctamente.
                    </p>
                  </div>
                </DialogTitle>

                <div class="mt-6">
                  <button
                    class="w-full bg-aces text-white font-semibold py-4 px-6 rounded-xl focus:outline-none shadow-lg"
                    @click="closeModal"
                  >
                    <span class="flex items-center justify-center">
                      <svg
                        class="w-5 h-5 mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      Entendido
                    </span>
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>
<script>
  import { ref, inject, watch, onBeforeUnmount } from "vue";
  import axios from "axios";
  import {
    TabGroup,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    DialogTitle,
  } from "@headlessui/vue";
  import { CheckIcon, SelectorIcon } from "@heroicons/vue/solid";
  import Bancos from "./Bancos.vue";
  import ImageViewer from "./ImageViewer.vue";
  import StepLoadingSkeleton from "./StepLoadingSkeleton.vue";
  import OrderPaidBanner from "./OrderPaidBanner.vue";
  export default {
    components: {
      StepLoadingSkeleton,
      OrderPaidBanner,
      TabGroup,
      TabList,
      Tab,
      TabPanels,
      TabPanel,
      Listbox,
      ListboxButton,
      ListboxOptions,
      ListboxOption,
      Bancos,
      ImageViewer,
      TransitionRoot,
      TransitionChild,
      Dialog,
      DialogOverlay,
      DialogTitle,
      SelectorIcon,
      CheckIcon,
    },
    props: {
      authenticatedUser: { type: Object, default: () => ({}) },
      orderId: { type: Number, default: null },
      isEditable: { type: Boolean, default: false },
      lockReason: { type: String, default: null },
      total: { type: Number, default: 0 },
    },
    setup(props, { emit }) {
      const isOpen = ref(false);
      const isLoading = ref(true);
      const existsPayment = ref(false);
      const confirmMPPayment = ref(false);
      const orderId = ref(props.orderId);
      const isShowBancos = ref(true);
      const effectiveTotal = ref(props.total);
      const newPayment = ref({});
      const chargeButton = ref(false);
      const church = ref({});
      const isConfirmOpen = ref(false);
      const hasConfirmed = ref(false);
      const banks = [
        /* "HSBC", */
        // "Provincia",
        // "Nación",
        "Macro",
        "Galicia",
        "Santander",
      ];
      const selectedBank = ref(banks[0]);
      const paymentTypes = {
        0: "Depósito",
        1: "Transferencia",
        2: "Efectivo",
        3: "Mercado Pago",
        4: "Campo",
      };

      const isModalOpen = ref(false);
      const globalState = inject("globalState"); // ✅ obtenemos el estado global

      const fetchChurch = async () => {
        const churchClientId = props.authenticatedUser?.churchClientId;
        if (!churchClientId) return;
        try {
          const { data } = await axios.get(`Churches/ById/${churchClientId}`);
          church.value = data || {};
        } catch (err) {
          console.error("No se pudo cargar la iglesia del subscriptor:", err);
          church.value = {};
        }
      };

      const fetch = async () => {
        isLoading.value = true;
        try {
          if (orderId.value != null) {
            if (effectiveTotal.value === 0) {
              try {
                const { data: statusData } = await axios.get(
                  `Orders/status?churchClientId=${props.authenticatedUser.churchClientId}&clientId=${props.authenticatedUser.clientId}`,
                );
                const order = (statusData.orders || []).find(
                  (o) => o.orderId === orderId.value,
                );
                if (order) effectiveTotal.value = order.total ?? 0;
              } catch (err) {
                console.log(err.response);
              }
            }
            try {
              const payRes = await axios.get(
                `Payments/byOrder?orderId=${orderId.value}`,
              );
              newPayment.value = payRes.data;
              existsPayment.value = payRes.status === 200;
              confirmMPPayment.value =
                payRes.data.type === 3 && payRes.data.state === 1;
            } catch (err) {
              console.log(err.response);
            }
            if (!existsPayment.value && props.isEditable) {
              const { data: generated } = await axios.get(
                `Payments/generate?orderId=${orderId.value}`,
              );
              newPayment.value = generated;
            }
          }
          newPayment.value.bankOperationDate = new Date()
            .toISOString()
            .split("T")[0];

          if (props.isEditable && !existsPayment.value && !hasConfirmed.value) {
            isConfirmOpen.value = true;
          }
        } catch (err) {
          console.log(err.response);
        } finally {
          isLoading.value = false;
        }
      };

      // ✅ Vuelve a llamar a getprovinces si se actualiza el token
      watch(
        () => globalState.tokenUpdated,
        (newVal) => {
          if (newVal === true) {
            console.log("Token actualizado. Reconsultando pagos...");
            fetch();
            fetchChurch();
            globalState.tokenUpdated = false; // Reinicia la bandera para futuras actualizaciones
          }
        },
      );

      // ✅ Emitir señal cuando se confirme un pago de Mercado Pago
      watch(
        () => confirmMPPayment.value,
        (newVal) => {
          if (newVal === true) {
            console.log("Pago de Mercado Pago confirmado. Emitiendo señal...");
            globalState.paymentCompleted = true;
          }
        },
      );

      const formatBody = () => {
        newPayment.value.bank = selectedBank.value;
        newPayment.value.orderId = orderId.value;
        const file = document.getElementById("file").files[0];
        // eslint-disable-next-line no-undef
        const formData = new FormData();
        Object.entries(newPayment.value).forEach(([k, v]) => {
          if (v === null) formData.append(k, "");
          else formData.append(k, v);
        });
        formData.append("file", file);
        return formData;
      };

      const post = async () => {
        chargeButton.value = true;
        const body = formatBody();
        const res = await axios
          .post(`Payments/create`, body)
          .then((res) => {
            isModalOpen.value = true;
            // ✅ Emitir señal de pago completado
            globalState.paymentCompleted = true;
            fetch();
            chargeButton.value = false;
            return res;
          })
          .catch((err) => {
            fetch();
            chargeButton.value = false;
            return err;
          });
        return res;
      };

      fetch();
      fetchChurch();

      let mpObserver = null;
      let wrapperObserver = null;
      let mpMessageHandler = null;

      const stopMPObserver = () => {
        if (mpObserver) {
          mpObserver.disconnect();
          mpObserver = null;
        }
        if (wrapperObserver) {
          wrapperObserver.disconnect();
          wrapperObserver = null;
        }
        if (mpMessageHandler) {
          window.removeEventListener("message", mpMessageHandler);
          mpMessageHandler = null;
        }
      };

      const watchMPClose = () => {
        stopMPObserver();

        // Escuchar postMessages del iframe de MP
        mpMessageHandler = (event) => {
          if (
            !event.origin.includes("mercadopago") &&
            !event.origin.includes("mercadolibre")
          )
            return;
          try {
            const data =
              typeof event.data === "string"
                ? JSON.parse(event.data)
                : event.data;
            if (data?.type === "close") {
              console.log(
                "[MP] Checkout cerrado por el usuario → limpiando componente MP",
              );
              cleanupMercadoPago();
            }
          } catch (_) {
            /* ignorar mensajes no parseables */
          }
        };
        window.addEventListener("message", mpMessageHandler);

        // Observar body para detectar cuando MP agrega su wrapper
        mpObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType !== 1) return;
              if (!node.classList?.contains("mp-mercadopago-checkout-wrapper"))
                return;

              console.log("[MP] Modal abierto, esperando cierre...");
            });

            mutation.removedNodes.forEach((node) => {
              if (node.nodeType !== 1) return;
              if (node.classList?.contains("mp-mercadopago-checkout-wrapper")) {
                console.log(
                  "[MP] Wrapper REMOVIDO del DOM → pago cancelado/cerrado",
                );
                cleanupMercadoPago();
              }
            });
          });
        });

        mpObserver.observe(document.body, { childList: true });
      };

      const cleanupMercadoPago = () => {
        stopMPObserver();
        try {
          window.checkout?.close?.();
        } catch (_) {
          /* ignorar si el SDK no expone close */
        }
        window.checkout = undefined;

        const checkoutScript = document.getElementById("checkout");
        if (checkoutScript) checkoutScript.remove();

        document
          .querySelectorAll(
            '[class*="mercadopago-checkout"], [id*="mercadopago-checkout"], ' +
              'iframe[src*="mercadopago"], iframe[src*="mercadolibre"]',
          )
          .forEach((el) => el.remove());

        document.body.style.overflow = "";
      };

      onBeforeUnmount(() => {
        cleanupMercadoPago();
      });

      const generateScript = async () => {
        if (effectiveTotal.value === 0) return;
        cleanupMercadoPago(); // limpiar instancia previa antes de crear una nueva
        const { data } = await axios
          .patch(`Payments/searchPreferenceId?orderId=${orderId.value}`)
          .catch((err) => console.log(err.response));
        const initCheckout = document.createElement("script");
        initCheckout.id = "checkout";
        initCheckout.type = "text/javascript";
        initCheckout.innerHTML = `
          var checkout = mp.checkout({
            preference: {
              id: "${data}",
            },
          });`;
        document.getElementById("app").appendChild(initCheckout);
      };

      const openMPCheckout = () => {
        window.checkout?.open?.();
        watchMPClose();
      };

      return {
        generateScript,
        openMPCheckout,
        existsPayment,
        confirmMPPayment,
        paymentTypes,
        isLoading,
        chargeButton,
        post,
        isOpen,
        isShowBancos,
        effectiveTotal,
        banks,
        selectedBank,
        formatBody,
        newPayment,
        isModalOpen,
        church,
        isConfirmOpen,

        closeModal() {
          isModalOpen.value = false;
          emit("paymentCompleted");
          emit("changeStep", 2);
        },

        confirmPayment() {
          hasConfirmed.value = true;
          isConfirmOpen.value = false;
        },
        goEditData() {
          isConfirmOpen.value = false;
          emit("changeStep", 1);
        },
        cancelConfirm() {
          isConfirmOpen.value = false;
          emit("changeStep", 4);
        },

        async savePayment() {
          await post();
        },
      };
    },
  };
</script>
<style>
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="submit"],
  button {
    -webkit-appearance: none;
  }
</style>
